import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface UsePreventBackNavigationProps {
  redirectPath?: string;
}

export function usePreventBackNavigation({ redirectPath = '/' }: UsePreventBackNavigationProps = {}) {
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, '', window.location.pathname);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.pathname);
      void navigate(redirectPath);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate, redirectPath]);
}
